import { useEffect, useState } from "react";
import { consent } from "@/lib/observability";
import type { ConsentState } from "@/lib/observability/types";

export function useConsent(): {
  state: ConsentState;
  acceptAll: () => void;
  setPartial: (cats: Partial<ConsentState["categories"]>) => void;
  isDecided: boolean;
} {
  const [state, setState] = useState<ConsentState>(() => consent.snapshot());
  useEffect(() => consent.subscribe(setState), []);
  return {
    state,
    acceptAll: () => consent.acceptAll(),
    setPartial: (cats) => consent.setPartial(cats),
    isDecided: state.status !== "unknown",
  };
}
